import { form, AppendixForm } from "./form";
const checkout = form;
const checkoutAppendix = AppendixForm;

const {
  formField: {
    accountOwner,
    bankAccountNumber,
    bankName,
    certificateNumber,
    chiefAccountant,
    documentNumber,
    signer,
    taxAgentCode,
    taxAgentName,
    taxCode,
    taxPayers,
    timeSign,
    whyRefund,
    sendTo,
    attachDocument,
  },
} = checkout;

const {
  formFieldAppendix: {
    from,
    to,
    payerNameAppendix,
    taxIdAppendix,
    taxAgentNameAppendix,
    taxAgentCodeAppendix,
  },
} = checkoutAppendix;

const initialValues = {
  [accountOwner.name]: "",
  [attachDocument.name]: "",
  [bankAccountNumber.name]: "",
  [bankName.name]: "",
  [certificateNumber.name]: "",
  [chiefAccountant.name]: "",
  [documentNumber.name]: "",
  [taxAgentCode.name]: "",
  [signer.name]: "",
  [taxAgentName.name]: "",
  [taxCode.name]: "",
  [taxPayers.name]: "",
  [whyRefund.name]: "",
  [timeSign.name]: "",
  [sendTo.name]: "",
  //appendix
  [from.name]: "",
  [to.name]: "",
  [payerNameAppendix.name]: "",
  [taxIdAppendix.name]: "",
  [taxAgentNameAppendix.name]: "",
  [taxAgentCodeAppendix.name]: "",
};

export default initialValues;
